"use client";

import { Button } from "@/components/shadcn/button";
import {
    Sheet,
    SheetContent,
    SheetTitle,
    SheetTrigger,
} from "@/components/shadcn/sheet";
import { Menu } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { AppShellSidebar, type AppShellUser } from "./app-shell-sidebar";
import type { AppShellSection } from "./nav";

export function AppShellMobileBar({
    active,
    user,
}: {
    active: AppShellSection;
    user: AppShellUser | null;
}) {
    const t = useTranslations("nav");
    const [open, setOpen] = useState(false);

    return (
        <div className="bg-sidebar border-sidebar-border flex items-center gap-2 border-b px-3 py-2.5 lg:hidden">
            <Sheet open={open} onOpenChange={setOpen}>
                <SheetTrigger asChild>
                    <Button variant="ghost" size="icon" aria-label={t("menu")}>
                        <Menu />
                    </Button>
                </SheetTrigger>
                <SheetContent side="left" className="w-72 p-0">
                    <SheetTitle className="sr-only">{t("menu")}</SheetTitle>
                    <AppShellSidebar
                        active={active}
                        user={user}
                        onNavigate={() => setOpen(false)}
                    />
                </SheetContent>
            </Sheet>
            <span className="text-base font-bold tracking-tight">
                Satranç<span className="text-primary">365</span>
            </span>
        </div>
    );
}
